import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { LoaderService } from '@app/core/services/loader/loader.service';
import { NotificationService } from '@app/core/services/notification/notification.service';
import { ErrorhandlerService } from '@app/shared/services/errorhandler/errorhandler.service';
import { Pattern } from '@app/shared/validators/pattern';
import { Business } from '../../models/Business';
import { SettingService } from '../../services/setting/setting.service';

@Component({
  selector: 'app-setting',
  templateUrl: './setting.component.html',
  styleUrls: ['./setting.component.css']
})
export class SettingComponent implements OnInit {
  accountSettingForm: FormGroup;
  businessDetails: any = null;
  constructor(private formBuilder: FormBuilder, private settingService: SettingService, private notificationService: NotificationService, private loaderService: LoaderService, private errorhandlerService: ErrorhandlerService) {
    this.initialize();
  }

  ngOnInit() {
    this.fn_getBusinessDetails();
  }

  initialize() {
    this.accountSettingForm = this.formBuilder.group({
      BusinessName: new FormControl('', Validators.required),
      Website: new FormControl(''),
      BusinessEmail: new FormControl('', Validators.compose([Validators.pattern(Pattern.EMAIL_PATTERN)])),
      SupportEmail: new FormControl('', Validators.compose([Validators.pattern(Pattern.EMAIL_PATTERN)])),
    })
  }

  fn_getBusinessDetails(){
    this.settingService.getBusinessDetails(parseInt(localStorage.getItem('userId')))
    .subscribe((res: any) => {
      if (res.StatusCode === 200) {
        this.businessDetails = res.Data.ResponseData;
        this.accountSettingForm.controls.BusinessName.setValue(this.businessDetails.BusinessName);
        this.accountSettingForm.controls.Website.setValue(this.businessDetails.Website);
        this.accountSettingForm.controls.BusinessEmail.setValue(this.businessDetails.BusinessEmail);
        this.accountSettingForm.controls.SupportEmail.setValue(this.businessDetails.SupportEmail);
        
        this.loaderService.hide();
      }  else {
        this.notificationService.error(res.Message, 'Record(s)');
        this.loaderService.hide();
      }
    }, err => {
      this.loaderService.hide();
      this.errorhandlerService.handleError(err);
    });
  }

  updateAccountSetting() {
    let business: Business = {
      UserId: parseInt(localStorage.getItem('userId')),
      BusinessName: this.accountSettingForm.value.BusinessName,
      BusinessEmail: this.accountSettingForm.value.BusinessEmail,
      SupportEmail: this.accountSettingForm.value.SupportEmail,
      Website: this.accountSettingForm.value.Website
    }

    this.settingService.updateAccount(business)
      .subscribe((res: any) => {
        if (res.StatusCode === 200) {
          localStorage.setItem('companyId', res.Data.ResponseData);
          this.notificationService.success('Success', 'Account info updated!');
          this.fn_getBusinessDetails()
          this.loaderService.hide();
        } else {
          this.loaderService.hide();
        }
      }, err => {
        this.loaderService.hide();
        this.errorhandlerService.handleError(err);
      });
  }
}
